import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import PredefinedPhrasesDiscoursePhraseForm from './PredefinedPhrasesDiscoursePhraseForm';
import { PredefineDiscoursePhrase } from './PredefinedPhrasesDiscourseSetup';

interface Props extends BaseModalProps {
	defaultValue?: PredefineDiscoursePhrase;
	onSuccess: () => void;
}

const PredefinedPhrasesDiscoursePhraseFormModal: React.FC<Props> = props => {
	return (
		<BaseModal title='component.predefinedPhrasesForm.modalTitle' {...props}>
			<PredefinedPhrasesDiscoursePhraseForm
				defaultValue={props.defaultValue}
				onSuccess={props.onSuccess}
			/>
		</BaseModal>
	);
};

export default PredefinedPhrasesDiscoursePhraseFormModal;
